import type { ListAuditLogsParams } from '@amarantos/api-client'
import { z } from 'zod/v3'

import { actionFilterValues, subjectFilterValues } from './audit-log-labels'

export const auditLogsSearchSchema = z.object({
	page: z.coerce.number().int().positive().default(1),
	perPage: z.coerce.number().int().positive().max(100).default(10),
	subject: z.enum(subjectFilterValues).default('all'),
	action: z.enum(actionFilterValues).default('all'),
})

export type AuditLogsSearch = z.infer<typeof auditLogsSearchSchema>

export function toListAuditLogsParams(search: AuditLogsSearch): ListAuditLogsParams {
	return {
		page: search.page,
		per_page: search.perPage,
		subject: search.subject === 'all' ? undefined : search.subject,
		action: search.action === 'all' ? undefined : search.action,
	}
}
